// extracted by mini-css-extract-plugin
module.exports = {"cyxf49j":"cyxf49j"};